import { Box } from '../../Box';
import React from 'react';
import styled, { css } from 'styled-components';
import { theme } from '../../theme';
import { Text } from '../../Text';
import { Icon } from '../../Icon';
export const StepItem = ({ label, isSimple = false, isCurrentStep, stepWidth, onClick, isCompleted = false, isLastCompleted = false, isLastItem = false, isDisabled, }) => {
    if (isSimple) {
        return (React.createElement(SimpleItem, { "$completed": isCompleted, "$lastCompleted": isLastCompleted, width: stepWidth, height: "12px" }));
    }
    return (React.createElement(ProgressItem, { flex: true, alignItems: "flex-start", "$completed": isCompleted, "$lastCompleted": isLastCompleted, width: stepWidth },
        React.createElement(ClickableArea, { flex: true, "data-testid": `step-item-${label}`, direction: "column", alignItems: "center", onClick: onClick, "$isDisabled": isDisabled },
            React.createElement(ProgressIndicator, { "$completed": isCompleted, "$currentStep": isCurrentStep, flex: true, alignItems: "center", justifyContent: "center" }, isCompleted && React.createElement(Icon, { render: "tick", size: 16, color: "cream" })),
            React.createElement(StyledText, { typo: "caption" }, label)),
        isCompleted && !isLastItem && React.createElement(CompletedBar, null)));
};
const lastCompleted = css `
  border-radius: 0 100px 100px 0;

  &:first-child {
    border-radius: 100px;
  }
`;
const borderRadiusCss = css `
  &:first-child {
    border-radius: 100px 0 0 100px;
  }

  ${({ $lastCompleted }) => $lastCompleted && lastCompleted}
`;
const SimpleItem = styled(Box) `
  position: relative;
  z-index: 1;
  ${borderRadiusCss}

  background: ${({ $completed }) => $completed ? theme.colors.pistachio : 'none'};
`;
const ProgressItem = styled(Box) `
  position: relative;
  z-index: 1;
  top: 9px;
  left: -10px;

  &:last-child {
    width: auto;
  }
`;
const ClickableArea = styled(Box) `
  position: relative;
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'auto' : 'pointer')};
`;
const ProgressIndicator = styled(Box) `
  border-radius: 50%;
  height: 24px;
  width: 24px;
  position: relative;
  z-index: 1;
  background: ${({ $completed, $currentStep }) => $completed || $currentStep ? theme.colors.pistachio : theme.colors.matcha};
`;
const StyledText = styled(Text) `
  margin-top: 2px;
  font-weight: ${theme.font.weight.medium};
  white-space: nowrap;
`;
const CompletedBar = styled(Box) `
  position: absolute;
  height: 12px;
  width: 100%;
  top: 7px;
  left: 13px;
  background: ${theme.colors.pistachio};
  z-index: 0;
`;
//# sourceMappingURL=StepItem.js.map